import {
    colorSelectChange,
    replaceImage
} from '../productDisplay/_images';
import {
    slickWrap
} from '../productListing/_imgSwipe';

const slickNSlide = (selectedImg) => {
    $('.chunk img').each(function() {
    	let imgRef = ($(this).attr('src') !== "") ? $(this).attr('src') : $(this).data('alts'),
        	imgSplit = imgRef.split('/'),
            imgName = imgSplit[imgSplit.length - 1];
        if (imgName === selectedImg + '.jpg') {
            let slide = $(this).parents('.chunk').data('slick-index');
            if ($(this).attr('src') === undefined || $(this).attr('src') === '')
              $(this).attr('src', $(this).data('alts'));
              $('#layoutProduct .slickWrapper').slick('slickGoTo', slide);
              return;
        }
    });
}

const imgSwipe_productpage = () => {
    let mainImgWrap = $('.mainProductImage'),
        mainImg = $('.mainImage'),
        altImgs = $('.alt-image-tile');
    const maltSwipe = (that, direction) => {
        let activeImg = $('div.chunk.slick-active img');
        if (activeImg.attr('src') === undefined || activeImg.attr('src') === '')
        	activeImg.attr("src", activeImg.data('alts'));
        var imgSrc = $('div.chunk.slick-active img').attr("src"),
        	imgSrcSplit = imgSrc.split('/'),
        	imgColor = imgSrcSplit[imgSrcSplit.length - 1].split('.jpg')[0];
        colorSelectChange(imgColor);
    }
    mainImg.wrap('<div class="chunk">');
    altImgs.each(function() {
        let altImgName = $(this).data('fullimage');
        var mainImgSplit = mainImg.attr('src').split('/'),
        	mainImgName = mainImgSplit[mainImgSplit.length - 1];
        if (mainImgName.indexOf('_zi') === -1 && $(this).data('twist') === 'alt-image-0') {
            replaceImage(mainImg, altImgName);
            mainImgName = altImgName;
        }
        if (mainImgName === altImgName+'.jpg')
        	return;
        if(mainImg != undefined){
        	var mainImgSrcSplit = mainImg.attr('src').split('/');
        	mainImgSrcSplit[mainImgSrcSplit.length - 1] = altImgName + '.jpg';
        	mainImgWrap.append(`<div class="chunk"><img src="" data-alts="${mainImgSrcSplit.join('/')}"/></div>`);
        }
    });
    slickWrap(mainImgWrap);
    $('#layoutProduct .slickWrapper').not('.slick-initialized').slick({
        arrows: false,
        asNavFor: '#alt-image-container .alt-image-list-container ul',
				infinite: false
    });
    $('#alt-image-container .alt-image-list-container ul').not('.slick-initialized').slick({
        asNavFor: '#layoutProduct .slickWrapper',
        focusOnSelect: true,
				infinite: false,
        slidesToShow: 3,
        swipeToSlide: true
    });
    $('#layoutProduct .slickWrapper').on('swipe', function(event, slick, direction) {
        maltSwipe($(this), direction);
    });
    $('#layoutProduct .alt-image-list-container').on('swipe', function(event, slick, direction) {
        maltSwipe($('#layoutProduct .slickWrapper'), direction);
    });
    let diParam = getUrlVar("di");
    if (diParam != undefined && diParam != "") slickNSlide(diParam);
}

export {
    imgSwipe_productpage,
    slickNSlide
}
